module.exports = __webpack_public_path__ + "static/img/3-7-select-noinfo-goods.8921c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-7-select-noinfo-goods.png
// module id = 1328
// module chunks = 0